export const Shapes = {
    MARKER: {id: 1, text: 'Marker', value: 'marker'},
    CIRCLE: {id: 2, text: 'Circle', value: 'circle'},
    POLYGON: {id: 3, text: 'Polygon', value: 'polygon'}
}
